import { FormCommentThread } from 'types';

export const prepareUniqueThreadAvatar = ({ dynamicComment, threads }) => {
  const uniqueThreads: any = {};

  if (dynamicComment) {
    threads[0].Comments.forEach((item) => {
      if (item.SenderUserId && !uniqueThreads[item.SenderUserId]) {
        item.CreatorId = item.SenderUserId;
        uniqueThreads[item.SenderUserId] = item;
      }
    });
  } else {
    threads.forEach((item) => {
      if (!uniqueThreads[item.CreatorEmail]) {
        uniqueThreads[item.CreatorEmail] = item;
      }
    });
  }

  return Object.values(uniqueThreads) as FormCommentThread[];
};
